import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { MessageService } from 'primeng/api';
import { StorageService } from 'src/app/services/storage.service';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { NavigationStart, Router } from '@angular/router';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { AccountManagementService } from 'src/app/services/account-management.service';
import { forkJoin, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { IdleSessionService } from 'src/app/services/idle-session.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MsalService } from '@azure/msal-angular';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { STATUS } from 'src/app/models/app-strings';
import { PreProcurementService } from 'src/app/services/pre-procurement.service';
interface City {
  name: string;
  code: string;
}

export function noSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value && typeof control.value === 'string') {
      if (control.value.trim().length === 0) {
        return { noSpaces: true };
      }
    }
    return null;
  };
}

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss'],
  standalone: false,
})
export class AccountSettingsComponent implements OnInit {
  firstName: any;
  lastName: any;
  email: any;
  organizationType: any;
  organizationName: any;
  phoneNumber: any;
  contactNumber: any;
  businessEmail: any;
  GST: any;
  PAN: any;
  CIN: any;
  userDetail: any;
  selectedCity!: City;
  email_notification_consent: boolean;
  reference_id_consent: any;
  order_reviewer: any;
  geo_fencing: boolean;
  otp_validation: any;
  defaultCustomCheck: boolean;
  firstPartyName: any;
  estampFieldsData: any = [];
  esignFieldsData: any = [];
  stateData: any;
  branchData: any;
  articles: any;
  selectedState: any;
  selectedStateCode: any;
  account_id: any;
  estamp_default_fields: any;
  esign_default_fields: any;
  selectedArticleCode: any;
  displaySigningPositions: {
    display_name: string;
    sign_position: string;
    id: number;
    disabled: boolean;
  }[];
  submitted: boolean = false;
  profileDetails: FormGroup;
  public phonePattern: string = '[0-9]{10}';
  estamp_default: any;
  esign_default: any;
  aadhaar_validation: any;
  auto_esign: any;
  is_authorized_signature: any;
  authentication_default: any;
  showOrderPayment: boolean = false;
  esign_webcam: any;
  order_payment: any;
  stamp_sign: any;
  estamp_field_editable: any;
  sync_second_party_and_price: boolean = false;
  pageReloaded: boolean = false;
  showEStampChange: boolean = false;
  showESignChange: boolean = false;
  targetRoute: string;
  shouldNavigate: boolean = true;
  estampFieldsModified: boolean = false;
  esignFieldsModified: boolean = false;
  currentUrl: string;
  estampForm: FormGroup;
  selectedAccount: any = {};
  accountUserData: any;
  branchDataAccount: any = [];
  stateDataAccount: any = [];
  selectedStateAccount: any;
  articlesAccount: any = [];
  stampDutyPaidByOptions = [
    { name: 'First Party', code: 'first_party_name' },
    { name: 'Second Party', code: 'second_party_name' },
  ];
  showInvalid: boolean = false;
  setEstampData: {};
  selectedAccountId: any;
  roleUser: any;
  isClient: boolean = false;
  openedAccordionIndex: number | null = null;
  storedStampData: any;
  addStampFormOpen: { [key: string]: boolean } = {};
  addStampModels: { [key: string]: any } = {};
  addStampArticles: { [key: string]: any[] } = {};
  addStampSaving: { [key: string]: boolean } = {};
  editStampOpen: { [key: string]: boolean } = {};
  editStampModels: { [key: string]: any } = {};
  editStampSaving: { [key: string]: boolean } = {};
  closeAccordian: boolean = true;
  ssoDefault: any;
  msTenantId: any = '';
  originalMsTenantId: any = '';
  isReadTenantId: boolean = true;
  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;
  isAdmin: string;
  editAadhaarPercentage: boolean = false;
  aadhaarPercentage = 75;
  aadhaar_name_match_percentage: any;
  esignExpireValidity: any;
  editEsignExpireValidity: boolean = false;
  processOptions: any;
  process_type: any;
  status = STATUS;
  groupedStampData: any[] = [];
  accordionOpenStates: boolean[] = [];
  isEsignTabOpen: boolean = false;
  eSignParties: any[] = [];
  isAbclMidMarket: boolean = false;
  public party: any = {};
  lowEstampBalanceAlert = 20;
  lowWalletBalanceAlert = 20;

  editLowEstampBalance = false;
  editLowWalletBalance = false;
  lowEstampBalanceError = false;
  lowWalletBalanceError = false;
  auto_approver: boolean = false;

  signMethodOptions = [
    { label: 'Aadhaar', value: 'AADHAAR' },
    { label: 'Electronic', value: 'ELECTRONIC' },
    { label: 'DSC', value: 'DSC' },
  ];

  signModeOptions = [
    { label: 'OTP', value: 'OTP' },
    { label: 'Biometric', value: 'Fingerprint' },
    { label: 'Face Recognition', value: 'FaceRecognition' },
  ];
  processOptionsAccount: any[] = [];

  constructor(
    private userService: UserProfileService,
    private messageService: MessageService,
    private router: Router,
    private storageService: StorageService,
    private featureFlagService: FeatureFlagService,
    private confirmationService: ConfirmationService,
    private primeng: PrimeNG,
    private fb: FormBuilder,
    private formBuilder: FormBuilder,
    private userDashboardService: UserDashboardService,
    private accountManagementService: AccountManagementService,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    private idleSessionService: IdleSessionService,
    private modalService: NgbModal,
    private authService: MsalService,
    private cookieService: CookieService,
    private preProcurementService: PreProcurementService,
    private cdr: ChangeDetectorRef,
  ) {
    this.account_id = this.storageService.getAccountId() || null;
    this.roleUser = this.storageService.getRole() || null;
    this.process_type = 'PRE_PROCUREMENT';

    this.isClient =
      this.roleUser === 'CLIENT' || this.roleUser === 'BRANCH-ADMIN';

    this.setupRouterEvents();

    this.initializeStaticData();
    this.storageService.abclMidMarket$.subscribe(() => {
      this.isAbclMidMarket = this.featureFlagService.isAbclMidMarket();
      this.applyMidMarketLogic();
    });
  }

  private setupRouterEvents(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.estampFieldsModified && !this.esignFieldsModified) {
          this.confirmEstampChanges();
        } else if (this.esignFieldsModified && !this.estampFieldsModified) {
          this.confirmEsignChanges();
        } else if (this.esignFieldsModified && this.estampFieldsModified) {
          this.confirmBothChanges();
        }
        this.currentUrl = event.url;
      }
    });
  }

  private applyMidMarketLogic(): void {
    if (this.isAbclMidMarket) {
      this.signMethodOptions = [{ label: 'Aadhaar', value: 'AADHAAR' }];

      if (this.party) {
        this.party.sign_method = 'AADHAAR';
      }

      if (this.esignFieldsData) {
        const field = this.esignFieldsData.find(
          (f) => f.value === 'signMethod',
        );
        if (field) {
          field.options = [
            { name: 'Aadhaar', sign_method: 'AADHAAR', inactive: false },
          ];
        }
      }
    }
  }

  private initializeStaticData(): void {
    this.displaySigningPositions = [
      {
        display_name: 'Top Left',
        sign_position: 'TOP_LEFT',
        id: 1,
        disabled: false,
      },
      {
        display_name: 'Top Centre',
        sign_position: 'TOP_CENTRE',
        id: 2,
        disabled: false,
      },
      {
        display_name: 'Top Right',
        sign_position: 'TOP_RIGHT',
        id: 3,
        disabled: false,
      },
      {
        display_name: 'Middle Left',
        sign_position: 'MIDDLE_LEFT',
        id: 4,
        disabled: false,
      },
      {
        display_name: 'Middle Right',
        sign_position: 'MIDDLE_RIGHT',
        id: 5,
        disabled: false,
      },
      {
        display_name: 'Bottom Left',
        sign_position: 'BOTTOM_LEFT',
        id: 6,
        disabled: false,
      },
      {
        display_name: 'Bottom Centre',
        sign_position: 'BOTTOM_CENTRE',
        id: 7,
        disabled: false,
      },
      {
        display_name: 'Bottom Right',
        sign_position: 'BOTTOM_RIGHT',
        id: 8,
        disabled: false,
      },
    ];

    this.esignFieldsData = [
      {
        label: 'Signatory Name',
        default: false,
        custom: '',
        value: 'partyName',
        type: 'text',
      },
      {
        label: 'Signatory Email',
        default: false,
        custom: '',
        value: 'partyEmail',
        type: 'email',
      },
      {
        label: 'Sign Method',
        default: false,
        custom: '',
        value: 'signMethod',
        type: 'dropdown',
        options: [
          { name: 'Aadhaar', sign_method: 'AADHAAR', inactive: false },
          { name: 'Electronic', sign_method: 'ELECTRONIC', inactive: false },
          { name: 'DSC', sign_method: 'DSC', inactive: false },
        ],
        optionValue: 'sign_method',
        optionLabel: 'name',
      },
      {
        label: 'Esign Mode',
        default: false,
        custom: '',
        value: 'aadhaarVerificationMethod',
        type: 'dropdown',
        options: [
          { name: 'OTP', sign_mode: 'OTP', inactive: false },
          { name: 'Biometric', sign_mode: 'Fingerprint', inactive: false },
        ],
        optionValue: 'sign_mode',
        optionLabel: 'name',
      },
      {
        label: 'Contact Number',
        default: false,
        custom: '',
        value: 'contactNumber',
        type: 'text',
      },
    ];

    this.processOptions = [
      { label: 'Inventory', value: 'PRE_PROCUREMENT' },
      { label: 'On the Fly', value: 'ON_THE_FLY' },
    ];
  }
  private addEstampSilent(index: number): void {
    const estampArray = this.estampDefaultFields
      .at(index)
      .get('estampDetails') as FormArray;
    estampArray.push(this.createEstamp());
  }

  getProcessTypeLabel(value: string): string {
    const option = this.processOptions.find((opt) => opt.value === value);
    return option ? option.label : value;
  }

  ngOnInit(): void {
    this.isAdmin = this.storageService.getRole();
    this.primeng.ripple.set(true);

    this.initializeForm();
    this.setAccountSettings();
    if (!this.accountUserData || this.accountUserData.length === 0) {
      this.getUserAccountData();
    }
    this.getUserDetail();
    this.reference_id_consent = this.storageService.getRefIdConsent() || null;

    // this.storageService.toggles$.subscribe(state => {
    //   if (state && state.estamp === false && state.esign === false) {
    //     this.forceDisableSettings();
    //   }
    // });
  }

  // forceDisableSettings() {
  //   this.estamp_default = false;
  //   this.esign_default = false;
  //   const params = {
  //     account_id: this.account_id,
  //     esign_default: this.status.OFF,
  //     estamp_default: this.status.OFF
  //   };

  //   this.userService.orderReviewConsent(params).subscribe({
  //     next: () => {
  //       this.setEsignDefault();
  //       this.setEstampDefault();
  //       // console.log("Settings disabled via Draft Edit");
  //     }
  //   });
  // }

  private initializeForm(): void {
    this.estampForm = this.createEstampForm();
    const fieldGroup = this.createEstampDefaultField();
    this.estampDefaultFields.push(fieldGroup);
    this.addEstampSilent(0);
    this.getDefaultFieldData(this.account_id);
  }

  toggleAccordion(index: number) {
    this.openedAccordionIndex =
      this.openedAccordionIndex === index ? null : index;
  }

  beforeUnloadListener = () => {
    return this.estampFieldsModified || this.esignFieldsModified ? true : null;
  };

  @HostListener('window:beforeunload')
  onBeforeUnload() {
    return this.beforeUnloadListener();
  }

  setAccountSettings() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.order_reviewer = res['content'].maker_checker;
      this.otp_validation = res['content'].esign_otp;
      this.lowEstampBalanceAlert =
        res['content'].low_estamp_balance_alert ?? 20;
      this.lowWalletBalanceAlert =
        res['content'].low_wallet_balance_alert ?? 20;
      this.geo_fencing = res['content'].geo_fencing;
      this.esign_webcam = res['content'].esign_webcam;
      this.estamp_field_editable = res['content'].estamp_field_editable;
      this.sync_second_party_and_price =
        res['content']?.additional_configuration?.sync_second_party_and_price ?? false;
      this.storageService.setSyncSecondPartyAndPrice(this.sync_second_party_and_price);
      this.stamp_sign =
        res['content']?.additional_configuration?.stamp_sign ??
        res['content']?.stamp_sign ??
        false;
      this.order_payment = res['content'].order_payment;
      this.aadhaar_validation = res['content'].aadhaar_validation;
      this.auto_esign = res['content'].auto_esign;
      this.auto_approver = res['content'].auto_approver;
      this.is_authorized_signature = res['content'].is_authorized_signature;
      this.aadhaar_name_match_percentage =
        res['content'].aadhaar_name_match_percentage;
      this.esignExpireValidity = res['content'].esign_expires_in;
      this.storageService.setOrderPayment(this.order_payment);
      this.storageService.setOrderReviewConsent(this.order_reviewer);
      this.storageService.setOtpValidation(this.otp_validation);
      this.storageService.setSignatoryImageCapture(this.esign_webcam);
      this.storageService.setStampEdit(this.estamp_field_editable);
      this.storageService.setAdharEdit(this.aadhaar_validation);
      this.storageService.setAutoEsignEdit(this.auto_esign);
      this.storageService.setAuthorisedSignature(this.is_authorized_signature);
      this.storageService.setAadhaarMatchPercentage(
        this.aadhaar_name_match_percentage,
      );
      this.storageService.setEsignExpireValidity(this.esignExpireValidity);
      this.storageService.setStampSignatory(this.stamp_sign);
      this.estamp_default = res['content'].estamp_default;
      this.storageService.setEstampDefault(this.estamp_default);
      this.esign_default = res['content'].esign_default;
      this.storageService.setEsignDefault(this.esign_default);
      this.authentication_default = res['content'].authentication_default;
      this.storageService.setAuthenticationDefault(this.authentication_default);
      this.ssoDefault = res['content'].sso_setting.sso_enabled;
      this.msTenantId = res['content'].sso_setting.MICROSOFT.tenant_id;
      this.originalMsTenantId = this.msTenantId;
      this.storageService.setSsoDefault(this.ssoDefault);
      this.applyMidMarketLogic();
      this.cdr.detectChanges();
    });
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (
      (event.keyCode != 8 &&
        !pattern.test(inputChar) &&
        event.keyCode !== 44) ||
      event.keyCode == 45
    ) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  isEmailValid(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  }

  isOnlySpaces(input: string): boolean {
    return input.trim() === '';
  }

  noLeadingSpacesValidator(value) {
    return value && /^\s/.test(value);
  }

  notOnlyNumbersValidator(value) {
    return value && (/^\d+$/.test(value) || /^\d+\s+$/.test(value));
  }

  onlyNumbers(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getDefaultFieldData(account_id) {
    this.userService.getDefaultFieldData(account_id).subscribe((res: any) => {
      const fetchedEsignData = res['content']['esign_default_fields'];

      if (Array.isArray(fetchedEsignData) && fetchedEsignData.length > 0) {
        this.eSignParties = [...fetchedEsignData];
      } else if (
        fetchedEsignData &&
        typeof fetchedEsignData === 'object' &&
        !Array.isArray(fetchedEsignData)
      ) {
        this.eSignParties = [fetchedEsignData];
      } else {
        this.eSignParties = [this.getNewPartyObject()];
      }

      this.esignFieldsModified = false;
      this.estampFieldsModified = false;

      // --- Estamp Settings (Unchanged) ---
      this.estamp_default_fields = res['content']['estamp_data'] || [];
      if (this.estamp_default_fields.length !== 0) {
        this.storedStampData = this.estamp_default_fields;
        this.processAndCacheGroupedStampData();
      } else {
        this.storedStampData = [];
        this.groupedStampData = [];
      }
      this.cdr.detectChanges();
    });
  }

  addESignParty() {
    this.eSignParties.push(this.getNewPartyObject());
    this.onSignChange('ESign');
  }

  removeESignParty(index: number) {
    const partyToRemove = this.eSignParties[index];
    const partyId = partyToRemove.default_esign_field_id || partyToRemove.id;

    if (partyId) {
      console.log('ID found! Calling DELETE API with ID:', partyId);

      const payload = {
        account_id: this.account_id,
        default_esign_field_id: partyId,
      };

      this.accountManagementService.deleteDefaultEsignField(payload).subscribe({
        next: (res: any) => {
          console.log('DELETE API Success:', res);
          this.eSignParties.splice(index, 1);
          this.onSignChange('ESign');
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Failed to delete signatory', err);
        },
      });
    } else {
      console.log('No ID found. This is an unsaved row, deleting locally.');
      this.eSignParties.splice(index, 1);
      this.onSignChange('ESign');
    }
  }

  getNewPartyObject() {
    return {
      party_name: '',
      party_email: '',
      sign_method: this.isAbclMidMarket ? 'AADHAAR' : '',
      sign_mode: '',
      contact_number: '',
    };
  }

  private processAndCacheGroupedStampData(): void {
    this.groupedStampData = [];

    this.storedStampData.forEach((estamp) => {
      const stampDuties =
        estamp?.estamp_default_fields?.state_wise_stamp_duty || [];

      if (stampDuties.length > 0) {
        const groupedByState = this.groupByState(stampDuties);

        this.groupedStampData.push({
          estamp: estamp,
          stateGroups: groupedByState,
        });
      }
    });
  }

  groupByState(stampDuties) {
    const grouped = {};
    stampDuties.forEach((stamp) => {
      const key = `${stamp.state_id}-${stamp.state_name}-${stamp.branch_name}`; // Group by both state and branch
      if (!grouped[key]) {
        grouped[key] = {
          state_id: stamp.state_id,
          state_name: stamp.state_name,
          branch_name: stamp.branch_name,
          stamps: [],
        };
      }
      grouped[key].stamps.push(stamp);
    });
    return Object.values(grouped);
  }

  private closeInlineStampForms(): void {
    this.addStampFormOpen = {};
    this.addStampModels = {};
    this.editStampOpen = {};
    this.editStampModels = {};
  }

  // ---------------------------------------------------------------------------
  // Inline "Add Stamp" flow (read-only e-stamp view)
   getStampGroupKey(groupedData: any, stateGroup: any): string {
    const accountId =
      groupedData?.estamp?.estamp_default_fields?.account_info?.id ?? '';
    return `${accountId}-${stateGroup?.state_id}-${stateGroup?.branch_name}`;
  }

  /** Opens a fresh inline add-stamp form for the given state group. */
  openAddStamp(groupedData: any, stateGroup: any): void {
    this.closeInlineStampForms();
    const key = this.getStampGroupKey(groupedData, stateGroup);
    const defaults = groupedData?.estamp?.estamp_default_fields || {};
    this.addStampFormOpen[key] = true;
    this.addStampModels[key] = {
      first_party_name: defaults.first_party_name || '',
      second_party_name: defaults.second_party_name || '',
      stamp_duty_paid_by: defaults.stamp_duty_paid_by || '',
      description: '',
      article_id: '',
      consideration_amount: 0,
      stamp_duty_amounts: null,
    };
    this.ensureArticlesForGroup(groupedData, stateGroup);
    this.cdr.detectChanges();
  }

  cancelAddStamp(groupedData: any, stateGroup: any): void {
    const key = this.getStampGroupKey(groupedData, stateGroup);
    this.addStampFormOpen[key] = false;
    delete this.addStampModels[key];
  }

  saveAddStamp(groupedData: any, stateGroup: any): void {
    const key = this.getStampGroupKey(groupedData, stateGroup);
    const model = this.addStampModels[key];

    if (!model || !model.description || !model.article_id) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill Purpose and Article before saving',
      });
      return;
    }

    const defaults = groupedData?.estamp?.estamp_default_fields || {};
    const hasExistingStamps = (stateGroup?.stamps?.length || 0) > 0;
    const partyDetailsChanged =
      (model.first_party_name || '') !== (defaults.first_party_name || '') ||
      (model.second_party_name || '') !== (defaults.second_party_name || '') ||
      (model.stamp_duty_paid_by || '') !== (defaults.stamp_duty_paid_by || '');

    if (hasExistingStamps && partyDetailsChanged) {
      this.confirmationService.confirm({
        key: 'estampSmallConfirm',
        header: 'Update Party Details',
        icon: 'pi pi-exclamation-circle',
        message:
          'The First Party Name, Second Party Name and Stamp Duty Paid By entered here will also be updated for all other E-Stamps in this state and branch. Do you want to continue?',
        acceptLabel: 'OK',
        rejectLabel: 'Cancel',
        acceptIcon: '',
        rejectIcon: '',
        acceptVisible: true,
        rejectVisible: true,
        accept: () => this.submitAddStamp(groupedData, stateGroup),
        reject: () => {},
      });
      return;
    }

    this.submitAddStamp(groupedData, stateGroup);
  }

  private submitAddStamp(groupedData: any, stateGroup: any): void {
    const key = this.getStampGroupKey(groupedData, stateGroup);
    const model = this.addStampModels[key];
    if (!model) {
      return;
    }

    const defaults = groupedData?.estamp?.estamp_default_fields || {};
    const firstStamp = (stateGroup?.stamps && stateGroup.stamps[0]) || {};
    const existingStamps = (stateGroup?.stamps || []).map((s: any) => ({
      id: s.id,
      description: s.description,
      article_id: s.article_id,
      consideration_amount: s.consideration_amount || 0,
      stamp_duty_amounts: Array.isArray(s.stamp_duty_amounts)
        ? s.stamp_duty_amounts
        : [s.stamp_duty_amounts],
    }));

    existingStamps.push({
      id: null,
      description: model.description,
      article_id: model.article_id,
      consideration_amount: model.consideration_amount || 0,
      stamp_duty_amounts: [model.stamp_duty_amounts],
    });

    const estampObject = {
      account_id: defaults?.account_info?.id ?? firstStamp.account_id,
      state_id: stateGroup.state_id,
      branch_id: firstStamp.branch_id ?? null,
      process_type: defaults.process_type,
      first_party_name: model.first_party_name || defaults.first_party_name,
      second_party_name: model.second_party_name || defaults.second_party_name,
      stamp_duty_paid_by: model.stamp_duty_paid_by || defaults.stamp_duty_paid_by,
      estamp: existingStamps,
    };

    const payload = { estamp_default_fields: [estampObject] };

    this.addStampSaving[key] = true;
    this.userService.postDefaultFieldData(payload).subscribe(
      (res: any) => {
        this.addStampSaving[key] = false;
        this.addStampFormOpen[key] = false;
        delete this.addStampModels[key];
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: res?.message || 'Stamp added successfully',
        });
        this.getDefaultFieldData(this.account_id);
      },
      (error) => {
        this.addStampSaving[key] = false;
        const detail =
          error?.error?.content?.errors?.[0] ||
          error?.error?.message ||
          'An error occurred while adding the stamp';
        this.messageService.add({ severity: 'error', detail });
      },
    );
  }

  private ensureArticlesForGroup(groupedData: any, stateGroup: any): void {
    const key = this.getStampGroupKey(groupedData, stateGroup);
    if (this.addStampArticles[key]) {
      return;
    }
    const accountId =
      groupedData?.estamp?.estamp_default_fields?.account_info?.id ??
      this.account_id;
    this.userDashboardService
      .getStatesByAccount(accountId)
      .subscribe((res: any) => {
        const states = res?.content || res?.['content'] || [];
        const matchedState = states.find(
          (st: any) => st.id === stateGroup?.state_id,
        );
        const stateCode = matchedState?.state_code;
        if (!stateCode) {
          return;
        }
        this.userService.getArticles(stateCode).subscribe((resp: any) => {
          const content = resp?.content || resp?.['content'] || [];
          this.addStampArticles[key] = content.map((article: any) => ({
            ...article,
            articleDisplay: `${article.article_code} - ${article.article_name}`,
          }));
          this.cdr.detectChanges();
        });
      });
  }

  getEditStampKey(groupedData: any, stateGroup: any, stamp: any): string {
    const groupKey = this.getStampGroupKey(groupedData, stateGroup);
    const stampId = stamp?.id ?? stamp?.article_id ?? '';
    return `${groupKey}::${stampId}`;
  }

  openEditStamp(groupedData: any, stateGroup: any, stamp: any): void {
    this.closeInlineStampForms();
    const editKey = this.getEditStampKey(groupedData, stateGroup, stamp);
    const defaults = groupedData?.estamp?.estamp_default_fields || {};

    this.editStampOpen[editKey] = true;
    this.editStampModels[editKey] = {
      id: stamp?.id ?? null,
      first_party_name:
        stamp?.first_party_name ?? defaults.first_party_name ?? '',
      second_party_name:
        stamp?.second_party_name ?? defaults.second_party_name ?? '',
      stamp_duty_paid_by:
        stamp?.stamp_duty_paid_by ?? defaults.stamp_duty_paid_by ?? '',
      description: stamp?.description ?? '',
      article_id: stamp?.article_id ?? '',
      consideration_amount: stamp?.consideration_amount ?? 0,
      stamp_duty_amounts: Array.isArray(stamp?.stamp_duty_amounts)
        ? stamp.stamp_duty_amounts[0]
        : stamp?.stamp_duty_amounts ?? null,
    };

    this.ensureArticlesForGroup(groupedData, stateGroup);
    this.cdr.detectChanges();
  }

  cancelEditStamp(groupedData: any, stateGroup: any, stamp: any): void {
    const editKey = this.getEditStampKey(groupedData, stateGroup, stamp);
    this.editStampOpen[editKey] = false;
    delete this.editStampModels[editKey];
  }

  saveEditStamp(groupedData: any, stateGroup: any, stamp: any): void {
    const editKey = this.getEditStampKey(groupedData, stateGroup, stamp);
    const model = this.editStampModels[editKey];

    if (!model || !model.description || !model.article_id) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill Purpose and Article before saving',
      });
      return;
    }

    const defaults = groupedData?.estamp?.estamp_default_fields || {};
    const firstStamp = (stateGroup?.stamps && stateGroup.stamps[0]) || {};
    const estampList = (stateGroup?.stamps || []).map((s: any) => {
      const isEdited =
        (model.id != null && s.id === model.id) || s === stamp;
      if (isEdited) {
        return {
          id: s.id ?? null,
          description: model.description,
          article_id: model.article_id,
          consideration_amount: model.consideration_amount || 0,
          stamp_duty_amounts: [model.stamp_duty_amounts],
        };
      }
      return {
        id: s.id,
        description: s.description,
        article_id: s.article_id,
        consideration_amount: s.consideration_amount || 0,
        stamp_duty_amounts: Array.isArray(s.stamp_duty_amounts)
          ? s.stamp_duty_amounts
          : [s.stamp_duty_amounts],
      };
    });

    const estampObject = {
      id: defaults?.id ?? null,
      account_id: defaults?.account_info?.id ?? firstStamp.account_id,
      state_id: stateGroup.state_id,
      branch_id: firstStamp.branch_id ?? null,
      process_type: defaults.process_type,
      first_party_name: model.first_party_name || defaults.first_party_name,
      second_party_name: model.second_party_name || defaults.second_party_name,
      stamp_duty_paid_by:
        model.stamp_duty_paid_by || defaults.stamp_duty_paid_by,
      estamp: estampList,
    };

    const payload = { estamp_default_fields: [estampObject] };

    this.editStampSaving[editKey] = true;
    this.userService.putDefaultFieldData(payload).subscribe(
      (res: any) => {
        this.editStampSaving[editKey] = false;
        this.editStampOpen[editKey] = false;
        delete this.editStampModels[editKey];
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: res?.message || 'Stamp updated successfully',
        });
        this.getDefaultFieldData(this.account_id);
      },
      (error) => {
        this.editStampSaving[editKey] = false;
        const detail =
          error?.error?.content?.errors?.[0] ||
          error?.error?.message ||
          'An error occurred while updating the stamp';
        this.messageService.add({ severity: 'error', detail });
      },
    );
  }

  onEsignChange(evt, field) {
    if (field.label === 'Sign Method')
      this.esignFieldsData[2].custom = evt.value;
    this.onSignChange('ESign');
  }

  getUserDetail() {
    this.userService.getUserDetail().subscribe((res: any) => {
      this.userDetail = res['content'];
      this.email_notification_consent =
        this.userDetail.email_notification_consent;
      this.cdr.detectChanges();
    });
  }

  toggleNotifyStatus() {
    const previousValue = this.email_notification_consent;
    this.email_notification_consent = !this.email_notification_consent;

    let reqParam = {
      notification_type: 'EMAIL',
      category: 'change_order_status',
    };

    this.userService.notificationConsent(reqParam).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity: 'success', detail: res.message });
      },
      error: (error) => {
        this.email_notification_consent = previousValue;
      },
    });
  }

  getRefIdConsent() {
    this.userService
      .getRefIdConsent('reference_number')
      .subscribe((res: any) => {
        this.storageService.setRefIdConsent(res.content.consent);
        this.reference_id_consent = res.content.consent;
      });
  }

  toggleRefNumStatus() {
    const previousValue = this.reference_id_consent;
    this.reference_id_consent = !this.reference_id_consent;
    let reqParam = {
      consent_type: 'reference_number',
    };
    this.userService.refIdConsent(reqParam).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity: 'success', detail: res.message });
        this.getRefIdConsent();
      },
      error: (error) => {
        this.reference_id_consent = previousValue;
      },
    });
  }

  toggleOrderReviewer() {
    const previousValue = this.order_reviewer;
    this.order_reviewer = !this.order_reviewer;
    let review = this.order_reviewer ? 'on' : 'off';
    let prams = { account_id: this.account_id, maker_checker: review };

    this.userService.orderReviewConsent(prams).subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'success',
          summary: `${
            review === 'on' ? 'Enabled' : 'Disabled'
          } Checker option upon place order!`,
        });
        this.setOrderReviewer();
      },
      error: (error) => {
        this.order_reviewer = previousValue;
      },
    });
  }
  setOrderReviewer() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.order_reviewer = res['content'].maker_checker;

      this.storageService.setOrderReviewConsent(this.order_reviewer);
    });
  }

  onOrderReviewerClick(event: Event) {
    event.preventDefault();

    const enableReviewer = !this.order_reviewer;

    if (enableReviewer) {
      this.userService.validateOrderReviewer(this.account_id).subscribe({
        next: (res) => {
          if (!res?.content || res.content.length === 0) {
            this.messageService.add({
              severity: 'error',
              detail: 'This account does not have any reviewer',
            });
            return;
          }
          this.toggleOrderReviewer();
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            detail: 'Failed to validate reviewers. Please try again.',
          });
        },
      });
    } else {
      this.toggleOrderReviewer();
    }
  }

  toggleOtpValidation() {
    const previousValue = this.otp_validation;
    this.otp_validation = !this.otp_validation;
    let esignOtp = this.otp_validation ? this.status.ON : this.status.OFF;
    let prams = { account_id: this.account_id, esign_otp: esignOtp };
    this.userService.orderReviewConsent(prams).subscribe({
      next: (res) => {
        this.setSignOtp();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `${
            esignOtp === this.status.ON
              ? this.status.ENABLED
              : this.status.DISABLED
          } OTP validation for E-sign Link`,
        });
      },
      error: (error) => {
        this.otp_validation = previousValue;
      },
    });
  }

  toggleGeoFencing() {
    const previousValue = this.geo_fencing;
    this.geo_fencing = !this.geo_fencing;

    const data = { account_id: this.account_id, active: this.geo_fencing };

    this.userService.addGeoFencing(data).subscribe({
      next: (res) => {
        if (res.status === 200) {
          this.geo_fencing = res.content.active;
          this.messageService.add({
            severity: this.status.SUCCESS,
            summary: 'Success',
            detail: 'Geo-fencing setting updated successfully',
          });
        }
      },
      error: (error) => {
        this.geo_fencing = previousValue;
      },
    });
  }

  setSignOtp() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.otp_validation = res['content'].esign_otp;

      this.storageService.setOtpValidation(this.otp_validation);
    });
  }
  // This is commented for build
  toggleDefaultCustom(defaultToggle) {
    defaultToggle = !defaultToggle;
  }

  cleanObject(obj: any): any {
    const cleanedObj: any = {};
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== '' && obj[key] !== null) {
        cleanedObj[key] = obj[key];
      }
    });
    return cleanedObj;
  }

  postDefaultEstampData() {
    this.submitted = true;

    if (
      this.estampFieldsData[0].default === true &&
      this.isOnlySpaces(this.estampFieldsData[0].custom)
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'First Party Name should not contain only spaces',
      });
      return;
    }

    if (
      this.estampFieldsData[0].default === true &&
      this.noLeadingSpacesValidator(this.estampFieldsData[0].custom)
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'First Party Name cannot start with spaces',
      });
      return;
    }

    if (
      this.estampFieldsData[0].default === true &&
      this.notOnlyNumbersValidator(this.estampFieldsData[0].custom)
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'First Party Name cannot contains only numbers',
      });
      return;
    }

    if (
      this.estampFieldsData[1].default === true &&
      this.isOnlySpaces(this.estampFieldsData[1].custom)
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Second Party Name should not contain only spaces',
      });
      return;
    }

    if (
      this.estampFieldsData[1].default === true &&
      this.noLeadingSpacesValidator(this.estampFieldsData[1].custom)
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Second Party Name cannot start with spaces',
      });
      return;
    }

    if (
      this.estampFieldsData[1].default === true &&
      this.notOnlyNumbersValidator(this.estampFieldsData[1].custom)
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Second Party Name cannot contains only numbers',
      });
      return;
    }
    let articleData = { article_code: '', id: '' };
    this.articles.forEach((element) => {
      if (element.article_code === this.estampFieldsData[6].custom) {
        articleData.article_code = element.article_code;
        articleData.id = element.id;
      }
    });
    let payload = {
      account_id: this.account_id,
      estamp_default_fields: this.cleanObject({
        first_party_name: this.estampFieldsData[0].custom,
        second_party_name: this.estampFieldsData[1].custom,
        stamp_duty_paid_by: this.estampFieldsData[2].custom,
        description: this.estampFieldsData[3].custom,
        state_code: this.selectedStateCode,
        branch_id: this.estampFieldsData[5].custom,
        article_code: articleData.article_code,
        article_id: articleData.id,
        stamp_duty_amount: this.estampFieldsData[7].custom,
        consideration_amount: this.estampFieldsData[8].custom,
        execution_date: null,
      }),
    };

    this.userService.postDefaultFieldData(payload).subscribe(
      (res: any) => {
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: res.message,
        });
        this.resetDefaultSettings();
        this.submitted = false;
        this.getDefaultFieldData(this.account_id);
        this.resetEstampFieldsModified();
      },
      (error) => {},
    );
  }

  markEstampFieldsAsModified() {
    this.estampFieldsModified = true;
  }

  resetEstampFieldsModified() {
    this.estampFieldsModified = false;
  }

  onEstampFieldChange() {
    this.markEstampFieldsAsModified();
  }

  postDefaultEsignData() {
    this.submitted = true;

    for (let i = 0; i < this.eSignParties.length; i++) {
      const party = this.eSignParties[i];
      const partyLabel = `Signer ${i + 1}`;

      if (!party.party_name || party.party_name.trim().length < 2) {
        this.messageService.add({
          severity: 'warn',
          detail: `${partyLabel}: Party Name cannot be blank`,
        });
        return;
      }

      const namePattern = /^[a-zA-Z\s]*$/;
      if (!namePattern.test(party.party_name)) {
        this.messageService.add({
          severity: 'warn',
          detail: `${partyLabel}: Party Name can only contain letters and spaces`,
        });
        return;
      }

      if (!this.isEmailValid(party.party_email)) {
        this.messageService.add({
          severity: 'warn',
          detail: `${partyLabel}: Email is not valid`,
        });
        return;
      }

      if (party.contact_number && party.contact_number.trim().length > 0) {
        const normalizedContact = party.contact_number.trim();

        // Check 10 digit length
        if (normalizedContact.length < 10) {
          this.messageService.add({
            severity: 'warn',
            detail: `${partyLabel}: Contact Number should be 10 digits`,
          });
          return;
        }
      }

      if (this.aadhaar_validation && party.sign_method === 'AADHAAR') {
        if (party.aadhaar_four_digit != null) {
          party.aadhaar_four_digit = String(party.aadhaar_four_digit).trim();
        }

        if (!party.aadhaar_four_digit || party.aadhaar_four_digit.length < 4) {
          this.messageService.add({
            severity: 'warn',
            detail: `${partyLabel}: The Aadhaar number must be exactly 4 digits.`,
          });
          return;
        }
      }
    }

    let payload = {
      account_id: this.account_id,
      esign_default_fields: this.eSignParties,
    };

    this.userService.postDefaultFieldData(payload).subscribe(
      (res: any) => {
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: res.message,
        });

        this.resetDefaultSettings();
        this.submitted = false;
        this.getDefaultFieldData(this.account_id);
        this.resetEsignFieldsModified();
        setTimeout(() => {
          this.isEsignTabOpen = false;
        }, 1000);
      },
      (error) => {},
    );
  }

  isDuplicateEmail(email: string, currentIndex: number): boolean {
    if (!email) return false;
    const normalizedCurrent = email.trim().toLowerCase();
    return this.eSignParties.some(
      (p, index) =>
        index !== currentIndex &&
        p.party_email?.trim().toLowerCase() === normalizedCurrent,
    );
  }

  isDuplicateContact(contact: string, currentIndex: number): boolean {
    if (!contact || contact.trim().length === 0) return false;
    const normalizedCurrent = contact.trim();
    return this.eSignParties.some(
      (p, index) =>
        index !== currentIndex &&
        p.contact_number?.trim() === normalizedCurrent,
    );
  }

  markEsignFieldsAsModified() {
    this.esignFieldsModified = true;
  }

  resetEsignFieldsModified() {
    this.esignFieldsModified = false;
  }

  onEsignFieldChange() {
    this.markEsignFieldsAsModified();
  }

  postDefaultData() {
    this.submitted = true;

    if (
      this.esignFieldsData[0].custom.length < 2 &&
      this.esignFieldsData[0].default === true
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Party Name cannot be blank',
      });
      return;
    }

    if (
      this.esignFieldsData[4].custom.length < 10 &&
      this.esignFieldsData[4].default === true
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Contact Number should be of 10 digits',
      });
      return;
    }

    if (
      this.esignFieldsData[1].default === true &&
      !this.isEmailValid(this.esignFieldsData[1].custom)
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Email is not valid',
      });
      return;
    }

    let payload = {
      account_id: this.account_id,
      esign_default_fields: {
        party_name: this.esignFieldsData[0].custom,
        party_email: this.esignFieldsData[1].custom,
        //"sign_position": this.esignFieldsData[3].custom,
        sign_method: this.esignFieldsData[2].custom,
        sign_mode: this.esignFieldsData[3].custom,
        contact_number: this.esignFieldsData[4].custom,
        aadhaar_four_digit: this.esignFieldsData[5]
          ? this.esignFieldsData[5].custom
          : null,
      },
    };

    this.userService.postDefaultFieldData(payload).subscribe((res: any) => {
      this.messageService.add({
        severity: this.status.SUCCESS,
        detail: res.message,
      });
      this.resetDefaultSettings();
      this.submitted = false;
      this.getDefaultFieldData(this.account_id);
      this.resetEstampFieldsModified();
      this.resetEsignFieldsModified();
    });
  }

  resetDefaultSettings() {
    this.estampFieldsData.forEach((field) => {
      field.default = false;
    });
    this.esignFieldsData.forEach((field) => {
      field.default = false;
    });
  }

  enterNumberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (
      (event.keyCode != 8 && !pattern.test(inputChar)) ||
      event.keyCode == 45
    ) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  handlePasteEvent(event: ClipboardEvent) {
    const paste = event.clipboardData.getData('text');
    // Regular expression to match only alphanumeric characters and spaces
    const regex = /^[a-zA-Z0-9 ]+$/;
    if (!regex.test(paste)) {
      event.preventDefault();
    }
  }

  toggleDefaultEstamp() {
    const previousValue = this.estamp_default;
    this.estamp_default = !this.estamp_default;

    let estamp_default = this.estamp_default ? this.status.ON : this.status.OFF;
    let prams = { account_id: this.account_id, estamp_default: estamp_default };

    this.userService.orderReviewConsent(prams).subscribe({
      next: (res) => {
        this.setEstampDefault();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `Estamp Settings Changed to ${
            estamp_default === this.status.ON
              ? this.status.DEFAULT
              : this.status.CUSTOM
          }`,
        });
      },
      error: (error) => {
        this.estamp_default = previousValue;
      },
    });
  }

  setEstampDefault() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.estamp_default = res['content'].estamp_default;
      this.storageService.setEstampDefault(this.estamp_default);
    });
  }

  toggleDefaultEsign() {
    const previousValue = this.esign_default;
    this.esign_default = !this.esign_default;

    let esign_default = this.esign_default ? this.status.ON : this.status.OFF;
    let prams = { account_id: this.account_id, esign_default: esign_default };

    this.userService.orderReviewConsent(prams).subscribe({
      next: (res) => {
        this.setEsignDefault();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `E-Sign Settings Changed to ${
            esign_default === this.status.ON
              ? this.status.DEFAULT
              : this.status.CUSTOM
          }`,
        });
      },
      error: (error) => {
        this.esign_default = previousValue;
      },
    });
  }

  setEsignDefault() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.esign_default = res['content'].esign_default;
      this.storageService.setEsignDefault(this.esign_default);
    });
  }
  toggleAuthentication() {
    this.authentication_default = !this.authentication_default;
    let authentication_default;
    if (this.authentication_default) {
      authentication_default = this.status.ON;
    } else {
      authentication_default = this.status.OFF;
    }
    let prams = {
      account_id: this.account_id,
      authentication_default: authentication_default,
    };
    this.userService.orderReviewConsent(prams).subscribe((res) => {
      this.setAuthenticationDefault();
      if (authentication_default === this.status.ON) {
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: 'Email OTP Authentication Changed to Default',
        });
      } else {
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: 'Email OTP Authentication Changed to Custom',
        });
      }
    });
  }

  toggleDefaultSSO() {
    this.ssoDefault = !this.ssoDefault;
    let params;
    let ssoStatus;
    if (this.ssoDefault) {
      ssoStatus = this.status.ON;
      params = {
        account_id: this.account_id,
        sso_setting: {
          MICROSOFT: this.msTenantId ? { tenant_id: this.msTenantId } : {},
          sso_enabled: true,
        },
      };
    } else {
      ssoStatus = this.status.OFF;
      params = {
        account_id: this.account_id,
        sso_setting: {
          MICROSOFT: this.msTenantId ? { tenant_id: this.msTenantId } : {},
          sso_enabled: false,
        },
      };
      this.tokenExchange();
    }

    this.userService.orderReviewConsent(params).subscribe((res) => {
      if (res) {
        if (ssoStatus === this.status.ON) {
          this.ssoDefault = true;
          this.storageService.setSsoDefault(true);
        }

        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `SSO Settings Changed to ${
            ssoStatus === this.status.ON
              ? this.status.ENABLED
              : this.status.DISABLED
          }`,
        });
      } else {
        this.messageService.add({
          severity: 'error',
          detail: 'Failed to update SSO settings.',
        });
      }
    });
  }

  tokenExchange() {
    let access_token = this.storageService.getToken();
    this.sendAccessTokenToBackend(access_token).subscribe({
      next: (res) => {
        console.log(res);
        this.setUserDetails(res);
        this.cookieService.delete('accessToken');
        this.authService.instance.setActiveAccount(null);
      },
      error: (error) => {
        console.error('Error sending token to backend', error);
      },
    });
  }

  sendAccessTokenToBackend(accessToken: string): Observable<any> {
    let apiUrl = environment.msLoginUrl;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    });

    const body = { access_token: accessToken, token_exchange: true };

    return this.httpClient.post<any>(apiUrl, body, { headers });
  }

  setUserDetails(res) {
    this.spinner.show();
    this.showInvalid = false;
    this.idleSessionService.reset();
    this.storageService.setOrganization(res['content'].organisation_name);
    this.storageService.setUser(res['content'].user);
    this.storageService.setToken(res['content'].token);
    this.storageService.setRole(res['content'].role);
    this.storageService.setAccountId(res['content'].account_id);
    this.storageService.setSignProvider(res['content'].sign_providers);
    this.setOrderReviewer2(res['content'].account_id);
    this.storageService.setBranchId(res['content'].branch_id);
    this.storageService.setLoginEmail(res['content'].user_email);
    this.storageService.setOrganizationId(res['content'].organisation_id);
    this.storageService.setUserID(res['content'].user_id);

    setTimeout(() => {
      this.router.navigate(['doqfy/profile/settings']);
    }, 1000);

    this.modalService.dismissAll();
  }

  setOrderReviewer2(account_id) {
    this.userService.getOrderReviewConsent(account_id).subscribe((res) => {
      this.order_reviewer = res['content'].maker_checker;
      this.otp_validation = res['content'].esign_otp;
      this.storageService.setOrderReviewConsent(this.order_reviewer);
      this.storageService.setOtpValidation(this.otp_validation);
      this.storageService.setEstampDefault(res['content'].estamp_default);
      this.storageService.setEsignDefault(res['content'].esign_default);
      this.storageService.setStampEdit(res['content'].estamp_field_editable);
      this.storageService.setAdharEdit(res['content'].aadhaar_validation);
      this.storageService.setAutoEsignEdit(res['content'].auto_esign);
      this.storageService.setAuthorisedSignature(res['content'].is_authorized_signature);
      this.storageService.setAadhaarMatchPercentage(
        res['content'].aadhaar_name_match_percentage,
      );
      this.storageService.setEsignExpireValidity(
        res['content'].esign_expires_in,
      );
      this.storageService.setOrderPayment(res['content'].order_payment);
      this.storageService.setAuthenticationDefault(
        res['content'].authentication_default,
      );
      this.storageService.setUploadDocxFile(res['content'].upload_docx_file);
      this.storageService.setSyncSecondPartyAndPrice(
        res['content']?.additional_configuration?.sync_second_party_and_price ?? false,
      );
      this.ssoDefault = res['content'].sso_setting.sso_enabled;
      this.storageService.setSsoDefault(this.ssoDefault);
    });
  }

  setSSODefault() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.ssoDefault = res['content'].sso_setting.sso_enabled;
      this.storageService.setSsoDefault(this.ssoDefault);
    });
  }

  saveTenantId() {
    if (this.isReadTenantId) {
      this.isReadTenantId = false;
    } else {
      if (this.msTenantId !== this.originalMsTenantId) {
        const params = {
          account_id: this.account_id,
          sso_setting: {
            MICROSOFT: {
              tenant_id: this.msTenantId,
            },
            sso_enabled: true,
          },
        };

        this.userService.orderReviewConsent(params).subscribe((res) => {
          this.setSSODefault();
          if (res) {
            this.isReadTenantId = true;
            this.originalMsTenantId = this.msTenantId;
            this.messageService.add({
              severity: this.status.SUCCESS,
              detail: 'tenant id updated successfully',
            });
          } else {
            this.messageService.add({
              severity: 'error',
              detail: 'something went wrong',
            });
          }
        });
      } else {
        this.messageService.add({
          severity: 'error',
          detail: 'tenant id is not changed',
        });
        this.isReadTenantId = true;
      }
    }
  }

  setAuthenticationDefault() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.authentication_default = res['content'].authentication_default;
      this.storageService.setAuthenticationDefault(this.authentication_default);
    });
  }

  toggleSignatoryImageCapture() {
    const previousValue = this.esign_webcam;
    this.esign_webcam = !this.esign_webcam;

    let enableCapture = this.esign_webcam ? this.status.ON : this.status.OFF;
    let prams = { account_id: this.account_id, esign_webcam: enableCapture };

    this.userService.orderReviewConsent(prams).subscribe({
      next: (res) => {
        this.setSignatoryImageCapture();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `${
            enableCapture === this.status.ON
              ? this.status.ENABLED
              : this.status.DISABLED
          } Signatory image capture for Esign`,
        });
      },
      error: (error) => {
        this.esign_webcam = previousValue;
      },
    });
  }

  setSignatoryImageCapture() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.esign_webcam = res['content'].esign_webcam;
      this.storageService.setSignatoryImageCapture(this.esign_webcam);
    });
  }

  //-----------------------------------------------------------------------------//
  toggleOrderPayment() {
    const previousValue = this.order_payment;
    this.order_payment = !this.order_payment;

    let orderPayment = this.order_payment ? this.status.ON : this.status.OFF;
    let prams = { account_id: this.account_id, order_payment: orderPayment };

    this.userService.orderReviewConsent(prams).subscribe({
      next: (res) => {
        this.setOrderPayment();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `${
            orderPayment === this.status.ON
              ? this.status.ENABLED
              : this.status.DISABLED
          } Order payment Option`,
        });
      },
      error: (error) => {
        this.order_payment = previousValue;
      },
    });
  }

  setOrderPayment() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.order_payment = res['content'].order_payment;
      this.storageService.setOrderPayment(this.order_payment);
    });
  }

  //------------- Edit Estamp Details -----------------------------------------------------------------//

  toggleEStampEdit() {
    const previousValue = this.estamp_field_editable;
    this.estamp_field_editable = !this.estamp_field_editable;

    let enableStampEdit = this.estamp_field_editable
      ? this.status.OFF
      : this.status.ON;
    let prams = {
      account_id: this.account_id,
      estamp_field_editable: enableStampEdit,
    };

    this.userService.orderReviewConsent(prams).subscribe({
      next: (res) => {
        this.setStampEdit();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `Estamp Default Settings Changed to ${
            enableStampEdit === this.status.ON ? 'Readonly' : 'Editable'
          }`,
        });
      },
      error: (error) => {
        this.estamp_field_editable = previousValue;
      },
    });
  }

  setStampEdit() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.estamp_field_editable = res['content'].estamp_field_editable;
      this.storageService.setStampEdit(this.estamp_field_editable);
    });
  }

  //----------------------------------------------------------------------------------------------//

  toggleAdharValidation() {
    const previousValue = this.aadhaar_validation;
    this.aadhaar_validation = !this.aadhaar_validation;

    let enableAdharValid = this.aadhaar_validation
      ? this.status.ON
      : this.status.OFF;
    let prams = {
      account_id: this.account_id,
      aadhaar_validation: enableAdharValid,
    };

    this.userService.orderReviewConsent(prams).subscribe({
      next: (res) => {
        this.setAdharEdit();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `${
            enableAdharValid === this.status.ON
              ? this.status.ENABLED
              : this.status.DISABLED
          } Aadhar Validation`,
        });
      },
      error: (error) => {
        this.aadhaar_validation = previousValue;
      },
    });
  }
  toggleAutoEsign() {
    const previousValue = this.auto_esign;
    this.auto_esign = !this.auto_esign;

    let enableAutoEsign = this.auto_esign ? this.status.ON : this.status.OFF;
    let params = { account_id: this.account_id, auto_esign: enableAutoEsign };

    this.userService.orderReviewConsent(params).subscribe({
      next: (res) => {
        this.setAutoEsignEdit();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `${
            enableAutoEsign === this.status.ON
              ? this.status.ENABLED
              : this.status.DISABLED
          } electronic auto esign`,
        });
      },
      error: (error) => {
        this.auto_esign = previousValue;
      },
    });
  }

toggleAutoApprover() {
   if (this.isAdmin !== 'ORGANISATION-ADMIN') {
    event.preventDefault();

    this.messageService.add({
      severity: 'error',
      detail: "You don't have permission to edit this"
    });

    return;
  }

  const previousValue = this.auto_approver;
  this.auto_approver = !this.auto_approver;
  let autoApprover = this.auto_approver ? this.status.ON : this.status.OFF;
  let params = {
    account_id: this.account_id,
    auto_approver: autoApprover
  };
  this.userService.orderReviewConsent(params).subscribe({
    next: (res) => {
      this.messageService.add({
        severity: 'success',
        detail: `Auto Approver ${
          autoApprover === this.status.ON ? 'Enabled' : 'Disabled'
        }`
      });
    },
    error: () => {
      this.auto_approver = previousValue;
    }
  });
}


  setAdharEdit() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.aadhaar_validation = res['content'].aadhaar_validation;
      this.storageService.setAdharEdit(this.aadhaar_validation);
    });
  }
  setAutoEsignEdit() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.auto_esign = res['content'].auto_esign;
      this.storageService.setAutoEsignEdit(this.auto_esign);
    });
  }
  toggleAuthorisedSignature() {
    const previousValue = this.is_authorized_signature;
    this.is_authorized_signature = !this.is_authorized_signature;

    let enableAuthorisedSignature = this.is_authorized_signature
      ? this.status.ON
      : this.status.OFF;
    let params = {
      account_id: this.account_id,
      is_authorized_signature: enableAuthorisedSignature,
    };

    this.userService.orderReviewConsent(params).subscribe({
      next: (res) => {
        this.setAuthorisedSignatureEdit();
        this.messageService.add({
          severity: this.status.SUCCESS,
          detail: `${
            enableAuthorisedSignature === this.status.ON
              ? this.status.ENABLED
              : this.status.DISABLED
          } authorized  seal and sign`,
        });
      },
      error: (error) => {
        this.is_authorized_signature = previousValue;
      },
    });
  }
  setAuthorisedSignatureEdit() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.is_authorized_signature = res['content'].is_authorized_signature;
      this.storageService.setAuthorisedSignature(this.is_authorized_signature);
    });
  }

  setAadhaarPercentage() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.aadhaar_name_match_percentage =
        res['content'].aadhaar_name_match_percentage;
      this.storageService.setAadhaarMatchPercentage(
        this.aadhaar_name_match_percentage,
      );
    });
  }

  setEsignExpireValidity() {
    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.esignExpireValidity = res['content'].esign_expires_in;
      this.storageService.setEsignExpireValidity(this.esignExpireValidity);
    });
  }

  onStampChange(value) {
    this.showEStampChange = true;
  }

  // Unchanged methods kept for context
  onSignChange(value) {
    this.showESignChange = true;
    this.markEsignFieldsAsModified(); // Replaced onEsignFieldChange since we don't have individual toggle events
  }

  confirmEstampChanges() {
    this.confirmationService.confirm({
      message:
        'You have unsaved changes in E-Stamp Settings. Do you want to leave without saving the changes?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-circle',
      accept: () => {
        this.postDefaultEstampData();
        setTimeout(() => {
          this.navigateToRoute(this.currentUrl);
        }, 1500);
      },
      acceptLabel: 'Save Changes',
      acceptIcon: 'pi pi',
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.estampFieldsModified = false;
            this.navigateToRoute(this.currentUrl);
            break;
          case ConfirmEventType.CANCEL:
            break;
        }
      },
      rejectLabel: 'Yes',
      rejectIcon: 'pi pi',
    });
  }

  confirmEsignChanges() {
    this.confirmationService.confirm({
      message:
        'You have unsaved changes in E-Sign Settings. Do you want to leave without saving the changes?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-circle',
      accept: () => {
        this.postDefaultEsignData();
        setTimeout(() => {
          this.navigateToRoute(this.currentUrl);
        }, 1500);
      },
      acceptLabel: 'Save Changes',
      acceptIcon: 'pi pi',
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.esignFieldsModified = false;
            this.navigateToRoute(this.currentUrl);
            break;
          case ConfirmEventType.CANCEL:
            break;
        }
      },
      rejectLabel: 'Yes',
      rejectIcon: 'pi pi',
    });
  }

  canDeactivate(): boolean {
    return this.estampFieldsModified || this.esignFieldsModified ? false : true;
  }

  confirmBothChanges() {
    this.confirmationService.confirm({
      message:
        'You have unsaved changes in E-Stamp and E-Sign Settings. Do you want to leave without saving the changes?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-circle',
      accept: () => {
        this.postDefaultData();
        setTimeout(() => {
          this.navigateToRoute(this.currentUrl);
        }, 1500);
      },
      acceptLabel: 'Save Changes',
      acceptIcon: 'pi pi',
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.estampFieldsModified = false;
            this.esignFieldsModified = false;
            this.navigateToRoute(this.currentUrl);
            break;
          case ConfirmEventType.CANCEL:
            break;
        }
      },
      rejectLabel: 'Yes',
      rejectIcon: 'pi pi',
    });
  }

  navigateToRoute(route: string) {
    this.router.navigateByUrl(route);
  }

  //---------------------------------------New Estamp Setting -------------------------------------------------------------------//

  getEstampSettingDetails() {}

  //-----------------------------------------Basic Code  ---------------------------------------------------------------------//
  closeAccordion() {
    this.closeUploadPopupBtn.nativeElement.click();
  }

  setEstampDataSettings(values: any, stateId: any): void {
    // Close accordion first
    this.closeAccordion();
    this.closeAccordian = false;

    // Build the form data structure WITHOUT async chaos
    this.buildEstampFormFromData(values, stateId);
  }

  // NEW METHOD: Build form synchronously where possible
  private buildEstampFormFromData(values: any, stateId: any): void {
    const data = values;

    // Clear existing form array first
    this.estampDefaultFields.clear();

    // Prepare all API requests upfront
    const accountId = data.estamp_default_fields.account_info.id;

    const apiRequests = {
      accounts: this.accountManagementService.getAccountPerUser(),
      states: this.userDashboardService.getStatesByAccount(accountId),
    };

    // Execute API requests in parallel
    forkJoin(apiRequests).subscribe({
      next: (responses) => {
        const accountData = responses.accounts['content'];
        const stateData = responses.states['content'];

        // Process the stamp duties for the selected state
        this.processStampDutiesForState(data, stateId, accountData, stateData);
      },
      error: (error) => {
        console.error('Error loading estamp settings:', error);
        this.messageService.add({
          severity: 'error',
          detail: 'Failed to load e-stamp settings',
        });
      },
    });
  }

  // NEW METHOD: Process stamp duties for a specific state
  private processStampDutiesForState(
    data: any,
    stateId: any,
    accountData: any[],
    stateData: any[],
  ): void {
    const stateDuties = data.estamp_default_fields.state_wise_stamp_duty;
    const groupMap = new Map<
      string,
      {
        formGroup: FormGroup;
        index: number;
        details: any[];
      }
    >();

    // Group stamp duties by account/branch/state
    stateDuties.forEach((detail: any) => {
      if (stateId === detail.state_id) {
        const groupKey = `${detail.account_id}-${detail.branch_id}-${detail.state_id}`;

        if (!groupMap.has(groupKey)) {
          groupMap.set(groupKey, {
            formGroup: this.createEstampDefaultField(),
            index: this.estampDefaultFields.length,
            details: [],
          });
        }

        groupMap.get(groupKey).details.push(detail);
      }
    });

    // Process each group
    groupMap.forEach((groupData, groupKey) => {
      this.processEstampGroup(groupData, data, accountData, stateData);
    });
  }

  // NEW METHOD: Process a single estamp group
  private processEstampGroup(
    groupData: { formGroup: FormGroup; index: number; details: any[] },
    data: any,
    accountData: any[],
    stateData: any[],
  ): void {
    const { formGroup, index, details } = groupData;
    const firstDetail = details[0];

    // Add form group to array
    this.estampDefaultFields.push(formGroup);

    // Patch account data
    const account = accountData.find(
      (acc) => acc.account_id === firstDetail.account_id,
    );

    if (account) {
      formGroup.patchValue(
        {
          account_id: account,
          id: data.estamp_default_fields.id,
        },
        { emitEvent: false },
      ); // Prevent triggering valueChanges
    }

    // Patch state data
    const selectedState = stateData.find(
      (state) => state.id === firstDetail.state_id,
    );

    if (selectedState) {
      this.stateDataAccount[index] = stateData;
      formGroup.patchValue(
        {
          state_id: selectedState,
        },
        { emitEvent: false },
      );

      // Load branch and article data, then populate stamps
      this.loadBranchAndArticleData(
        formGroup,
        index,
        firstDetail,
        selectedState,
        data,
        details,
      );
    }
  }

  private loadBranchAndArticleData(
    formGroup: FormGroup,
    index: number,
    detail: any,
    selectedState: any,
    data: any,
    allDetails: any[],
  ): void {
    const branchAndArticleRequests = {
      branches: this.accountManagementService.getBranchPerUser(
        detail.account_id,
        detail.state_id,
      ),
      articles: this.userService.getArticles(selectedState.state_code),
    };

    forkJoin(branchAndArticleRequests).subscribe({
      next: (responses) => {
        // Store branch data
        this.branchDataAccount[index] = responses.branches['content'];

        // Patch branch ID and process_type
        formGroup.patchValue(
          {
            branch_id: detail.branch_id,
            process_type:
              data.estamp_default_fields.process_type || 'PRE_PROCUREMENT',
          },
          { emitEvent: false },
        );

        // Process and store article data
        const processedArticles = responses.articles['content'].map(
          (article: any) => ({
            ...article,
            articleDisplay: `${article.article_code} - ${article.article_name}`,
          }),
        );
        this.articlesAccount[index] = processedArticles;

        // Load process options for this state, THEN populate estamp details
        this.preProcurementService
          .getStampTypeByState(selectedState.state_code)
          .subscribe({
            next: (res: any) => {
              const content = res?.content?.[0];
              const options = [];

              if (content?.pre_estamp || content?.traditional) {
                options.push({ label: 'Inventory', value: 'PRE_PROCUREMENT' });
              }
              if (content?.estamp) {
                options.push({ label: 'On the Fly', value: 'ON_THE_FLY' });
              }
              if (content?.esbtr) {
                options.push({ label: 'ESBTR', value: 'ESBTR' });
              }

              this.processOptionsAccount[index] = options;

              // Now populate estamp details AFTER process options are ready
              this.populateEstampDetails(formGroup, data, allDetails);
            },
            error: (err) => {
              console.error('Failed to load stamp type by state:', err);
              this.processOptionsAccount[index] = [];

              // Still populate estamp details even if this call fails
              this.populateEstampDetails(formGroup, data, allDetails);
            },
          });
      },
      error: (error) => {
        console.error('Error loading branch/article data:', error);
      },
    });
  }

  private populateEstampDetails(
    formGroup: FormGroup,
    data: any,
    details: any[],
  ): void {
    const estampDetailsArray = formGroup.get('estampDetails') as FormArray;

    // Clear existing details
    estampDetailsArray.clear();

    // Add all stamp details at once (NO setTimeout!)
    details.forEach((detail: any) => {
      const estampGroup = this.createEstamp();

      estampGroup.patchValue(
        {
          id: detail.id,
          first_party_name: data.estamp_default_fields.first_party_name,
          second_party_name: data.estamp_default_fields.second_party_name,
          stamp_duty_paid_by: data.estamp_default_fields.stamp_duty_paid_by,
          description: detail.description,
          article_id: detail.article_id,
          stamp_duty_amounts: detail.stamp_duty_amounts[0],
          consideration_amount: detail.consideration_amount,
        },
        { emitEvent: false },
      );

      estampDetailsArray.push(estampGroup, { emitEvent: false });
    });

    // Emit event once after all details are added
    estampDetailsArray.updateValueAndValidity();
  }

  //--------------------------------------------------------------------------------------------------------------------------------//

  createEstampForm(): FormGroup {
    return this.fb.group({
      estamp_default_fields: this.fb.array([]),
    });
  }

  createEstampDefaultField(): FormGroup {
    const group = this.fb.group({
      account_id: [null, Validators.required],
      state_id: [null, Validators.required],
      branch_id: [null],
      id: [null],
      process_type: [null, Validators.required],
      estampDetails: this.fb.array([]),
    });

    return group;
  }

  createEstamp(): FormGroup {
    return this.fb.group({
      id: [null],
      first_party_name: ['', Validators.required],
      second_party_name: [''],
      stamp_duty_paid_by: ['', Validators.required],
      description: ['', Validators.required],
      article_id: ['', Validators.required],
      stamp_duty_amounts: [null],
      consideration_amount: [0],
    });
  }

  onNumberKeyPress(event: KeyboardEvent): void {
    // Block decimal point, minus sign, 'e', and other non-digit characters
    if (
      event.key === '.' ||
      event.key === '-' ||
      event.key === 'e' ||
      event.key === 'E' ||
      event.key === '+'
    ) {
      event.preventDefault();
    }
  }

  onNumberPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text');
    // Check if pasted content contains decimal point or non-numeric characters
    if (pastedText && !/^\d+$/.test(pastedText)) {
      event.preventDefault();
    }
  }

  get estampDefaultFields(): FormArray {
    return this.estampForm.get('estamp_default_fields') as FormArray;
  }

  getEstamps(index: number): FormArray {
    return this.estampDefaultFields.at(index).get('estampDetails') as FormArray;
  }

  addEstampDefaultField(index: number): void {
    if (this.estampForm.valid) {
      this.closeInlineStampForms();
      const fieldGroup = this.createEstampDefaultField();
      this.estampDefaultFields.push(fieldGroup);
      this.addEstamp(index);
    } else {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill all the Details Before Adding New',
      });
    }
  }

  removeEstampDefaultField(index: number, data, type): void {
    const currentId = data.value?.id;
    this.estampDefaultFields.removeAt(index);
    if (type === 'api' && currentId) {
      const deleteObj = { id: currentId };

      this.accountManagementService.deleteDefaultEstamp(deleteObj).subscribe({
        next: (res) => {
          this.messageService.add({
            severity: this.status.SUCCESS,
            detail: 'Record deleted successfully',
          });

          this.resetEverything();
          this.getDefaultFieldData(this.account_id);
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            detail: 'Failed to delete record',
          });

          this.estampDefaultFields.insert(index, data);
        },
      });

      if (data.value.estampDetails && data.value.estampDetails.length > 0) {
        data.value.estampDetails.forEach((element) => {
          const detailDeleteObj = { id: element.id };
          this.accountManagementService
            .deleteEstamp(detailDeleteObj)
            .subscribe({
              next: (res) => {},
              error: (err) => {
                console.error('Failed to delete estamp detail:', err);
              },
            });
        });
      }
    }
  }

  removeEstampDefault(data) {
    const currentId = data.estamp_default_fields.account_info.id;
    if (currentId) {
      const Obj = { id: currentId };
      this.accountManagementService
        .deleteDefaultEstamp(Obj)
        .subscribe((res) => {
          this.resetEverything();
          this.getDefaultFieldData(this.account_id);
        });
    }
  }

  addEstamp(index: number, skipValidation: boolean = false): void {
    const estampsArray = this.getEstamps(index);
    if (!skipValidation && !estampsArray.valid) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill all the Details Before Adding New',
      });
      return;
    }
    const newEstamp = this.createEstamp();
    if (estampsArray.length > 0 && !skipValidation) {
      const firstStamp = estampsArray.at(0).value;
      newEstamp.patchValue(
        {
          first_party_name: firstStamp.first_party_name || '',
          second_party_name: firstStamp.second_party_name || '',
          stamp_duty_paid_by: firstStamp.stamp_duty_paid_by || '',
        },
        { emitEvent: false },
      );
    }
    estampsArray.push(newEstamp, { emitEvent: false });
    estampsArray.updateValueAndValidity();
    this.messageService.add({
      severity: 'success',
      detail: 'E-Stamp added successfully',
    });
  }

  removeEstamp(parentIndex: number, index: number, est): void {
    if (est.value.id) {
      const data = { id: est.value.id };
      this.accountManagementService.deleteEstamp(data).subscribe((res) => {
        this.messageService.add({ severity: 'warn', detail: res.message });
        this.resetEverything();
        this.getDefaultFieldData(this.account_id);
      });
    } else {
      this.getEstamps(parentIndex).removeAt(index);
    }
  }

  removeEstampValues(est) {
    if (est.id) {
      const data = { id: est.id };
      this.accountManagementService.deleteEstamp(data).subscribe((res) => {
        this.messageService.add({ severity: 'warn', detail: res.message });
        this.resetEverything();
        this.getDefaultFieldData(this.account_id);
      });
    }
  }

  getUserAccountData() {
    this.accountManagementService.getAccountPerUser().subscribe((res) => {
      this.accountUserData = res['content'];
      this.getAccountDetailsById();
    });
  }

  getAccountDetailsById() {
    this.accountManagementService
      .getAccountDetail(this.account_id)
      .subscribe((res) => {
        const userAccount = res['content'][0];
        if (userAccount) {
          const exists = this.accountUserData.some(
            (element) => element.account_id === userAccount.id,
          );

          if (!exists) {
            userAccount.account_id = userAccount.id;
            this.accountUserData.push(userAccount);
          }
          this.selectedAccount = userAccount;
        }
      });
  }

  onSelectedAccount(event, i, data) {
    if (data.value.id) {
      const Obj = { id: data.value.id };
      this.accountManagementService
        .deleteDefaultEstamp(Obj)
        .subscribe((res) => {
          this.messageService.add({
            severity: 'warn',
            detail:
              'Previous Account Data is Deleted Please save to Store new Account Details ',
          });
        });
    }

    this.getStateDetailsAccount(i, event.value.account_id);
    this.storageService.setAccountId(event.value.account_id);
    this.selectedAccountId = event.value.account_id;
    const stateId =
      this.estampForm.value.estamp_default_fields[i]?.state_id?.id;
    if (stateId) {
      this.getSelectedAccount(i, stateId);
    }
  }

  onAccountClick(event, i, data) {
    if (data.value.id) {
      this.messageService.add({
        severity: 'warn',
        detail:
          'Previous Account Data will be Deleted on changing the Account ',
      });
    }
  }

  getStateDetailsAccount(i, id) {
    this.userDashboardService.getStatesByAccount(id).subscribe((res: any) => {
      this.stateDataAccount[i] = res['content'];
    });
  }

  onStateChange(event: any, i: number) {
    this.selectedStateAccount = event.value;
    this.getSelectedAccount(i, event.value.id);
    this.getArticlesAccount(i);
    this.loadProcessOptionsByState(event.value.state_code, i);
  }

  onBranchChange(event: any, i) {}

  getSelectedAccount(i, id) {
    this.branchDataAccount[i] = [];
    this.accountManagementService
      .getBranchPerUser(
        this.estampForm.value.estamp_default_fields[i].account_id.account_id,
        id,
      )
      .subscribe((res) => {
        this.branchDataAccount[i] = res['content'];
      });
  }

  getArticlesAccount(i) {
    this.userService
      .getArticles(this.selectedStateAccount.state_code)
      .subscribe((resp: any) => {
        if (resp.status === 200) {
          this.articlesAccount[i] = resp['content'];

          this.articlesAccount[i].forEach((element, index) => {
            let articleDisplay =
              element.article_code + '-' + element.article_name;
            element['articleDisplay'] = articleDisplay;
          });
        }
      });
  }

  onArticleChange(event, i, j) {
    const articleAccount = this.articlesAccount[i];
    const selectedArticle = articleAccount.find(
      (element) => element.id === event.value,
    );

    if (selectedArticle) {
      const selectedArticleAmount = selectedArticle.amount;
      if (selectedArticleAmount) {
        const estampDetailControl = this.estampDefaultFields
          .at(i)
          .get('estampDetails')
          ['controls'].at(j);

        // Initialize the update object
        const updateValues = {
          consideration_amount: 0,
          stamp_duty_amounts: [],
        };

        if (selectedArticleAmount.min_consideration_amount) {
          updateValues.consideration_amount =
            selectedArticleAmount.min_consideration_amount;
        } else {
          updateValues.consideration_amount = 0;
        }

        if (selectedArticleAmount.min_stamp_duty) {
          updateValues.stamp_duty_amounts = [
            selectedArticleAmount.min_stamp_duty,
          ];
        } else if (selectedArticleAmount.fix_stamp_duty) {
          updateValues.stamp_duty_amounts = [
            selectedArticleAmount.fix_stamp_duty,
          ];
        }

        // Apply the updates
        estampDetailControl.patchValue(updateValues);
      }
    }
  }

  private findDuplicateStateBranch(): {
    stateName: string;
    branchName: string;
    inForm: boolean;
  } | null {
    const buildKey = (accountId: any, stateId: any, branchId: any) =>
      `${accountId ?? ''}|${stateId ?? ''}|${branchId ?? ''}`;

    const savedKeys = new Set<string>();
    (this.storedStampData || []).forEach((estamp: any) => {
      const fields = estamp?.estamp_default_fields;
      (fields?.state_wise_stamp_duty || []).forEach((detail: any) => {
        savedKeys.add(
          buildKey(
            detail.account_id ?? fields?.account_info?.id,
            detail.state_id,
            detail.branch_id,
          ),
        );
      });
    });

    const formKeys = new Set<string>();
    const entries = this.estampDefaultFields.controls;
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i].value;
      const isExistingRecord = (entry.estampDetails || []).some(
        (d: any) => d?.id,
      );
      if (isExistingRecord) {
        continue;
      }

      const key = buildKey(
        entry.account_id?.account_id,
        entry.state_id?.id,
        entry.branch_id,
      );
      const stateName = entry.state_id?.state_name || 'selected state';
      const branchName =
        (this.branchDataAccount[i] || []).find(
          (b: any) => b.id === entry.branch_id,
        )?.name || '';

      if (savedKeys.has(key)) {
        return { stateName, branchName, inForm: false };
      }
      if (formKeys.has(key)) {
        return { stateName, branchName, inForm: true };
      }
      formKeys.add(key);
    }
    return null;
  }

  postDefaultAccountData() {
    this.submitted = true;

    if (this.estampForm.valid) {
      const duplicate = this.findDuplicateStateBranch();
      if (duplicate) {
        const location = duplicate.branchName
          ? `${duplicate.stateName} state and ${duplicate.branchName} branch`
          : `${duplicate.stateName} state`;
        this.confirmationService.confirm({
          key: 'estampSmallConfirm',
          header: 'Already Added',
          icon: 'pi pi-exclamation-circle',
          message: duplicate.inForm
            ? `E-Stamp for ${location} is added more than once. Please add all stamps under a single entry.`
            : `E-Stamp for ${location} is already added. Please use "Add Stamp" in the existing entry under E-stamp Details.`,
          acceptLabel: 'OK',
          rejectLabel: 'Cancel',
          acceptIcon: '',
          rejectIcon: '',
          acceptVisible: true,
          rejectVisible: false,
          accept: () => {},
          reject: () => {},
        });
        return;
      }

      const accountEstamp = [];

      // Loop through each element in estamp_default_fields
      this.estampForm.value.estamp_default_fields.forEach((element, index) => {
        const estampObject = {
          account_id: element.account_id.account_id,
          state_id: element.state_id.id,
          branch_id: element.branch_id,
          process_type: element.process_type,
          first_party_name: element.estampDetails[0].first_party_name,
          second_party_name: element.estampDetails[0].second_party_name,
          stamp_duty_paid_by: element.estampDetails[0].stamp_duty_paid_by,
          estamp: [],
        };
        // Loop through each estampDetails for the current element
        element.estampDetails.forEach((res) => {
          estampObject.estamp.push({
            id: res.id,
            description: res.description,
            article_id: res.article_id,
            consideration_amount: res.consideration_amount
              ? res.consideration_amount
              : 0,
            stamp_duty_amounts: [res.stamp_duty_amounts],
          });
        });

        accountEstamp.push(estampObject);
      });

      const data = {
        estamp_default_fields: accountEstamp,
      };

      this.userService.postDefaultFieldData(data).subscribe(
        (res: any) => {
          this.messageService.add({
            severity: this.status.SUCCESS,
            detail: res.message,
          });
          this.submitted = false;
          this.closeInlineStampForms();

          // Update the storedStampData array with the new data
          this.storedStampData = accountEstamp;
          // console.log("Stored Stamp Data", this.storedStampData);

          // Reset the form and other necessary fields
          this.resetDefaultSettings();
          this.resetEverything();
          this.getDefaultFieldData(this.account_id);
          this.resetEstampFieldsModified();
          this.resetEsignFieldsModified();
        },
        (error) => {
          // Check if the error has nested content.errors array
          if (
            error.error?.content?.errors &&
            error.error.content.errors.length > 0
          ) {
            // Display the first error from the errors array
            this.messageService.add({
              severity: 'error',
              detail: error.error.content.errors[0],
            });
          } else {
            // Fallback to the message property
            this.messageService.add({
              severity: 'error',
              detail: error.error?.message || 'An error occurred',
            });
          }
        },
      );
    } else {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fill in the mandatory E-Stamp details',
      });
    }
  }

  onNameChange(i: number) {
    let j = 0;
    const estampFormArray = this.estampDefaultFields
      .at(i)
      .get('estampDetails') as FormArray;
    const firstName = this.getEstamps(i).value[j].first_party_name;
    const secondName = this.getEstamps(i).value[j].second_party_name;
    const paidBy = this.getEstamps(i).value[j].stamp_duty_paid_by;
    estampFormArray.controls.forEach((control) => {
      control.patchValue({
        first_party_name: firstName,
        second_party_name: secondName,
        stamp_duty_paid_by: paidBy,
      });
    });
  }

  //--------------------------------------Reset All -------------------------------------------------//

  resetEstampForm() {
    this.estampForm.reset();
    this.estampDefaultFields.clear(); // Clear all FormArray elements

    // Add one initial default field if needed
    this.estampDefaultFields.push(this.createEstampDefaultField());
  }

  resetEstampDefaultField(index: number) {
    const defaultField = this.estampDefaultFields.at(index) as FormGroup;
    defaultField.reset();
    const estampDetails = defaultField.get('estampDetails') as FormArray;
    estampDetails.clear();

    // Add one initial Estamp if needed
    estampDetails.push(this.createEstamp());
  }

  resetAllEstampDefaultFields() {
    this.estampDefaultFields.controls.forEach((control, index) => {
      this.resetEstampDefaultField(index);
    });
  }

  // Example usage:
  resetEverything() {
    this.resetEstampForm();
    this.resetAllEstampDefaultFields();
  }

  toggleEditAadhaarPercentage() {
    this.editAadhaarPercentage = true;
  }

  toggleEditEsignValidity() {
    this.editEsignExpireValidity = true;
  }

  saveAadhaarPercentage() {
    this.editAadhaarPercentage = false;
    let params = {
      account_id: this.account_id,
      aadhaar_name_match_percentage: this.aadhaar_name_match_percentage,
    };
    this.userService.orderReviewConsent(params).subscribe((res) => {
      this.setAadhaarPercentage();
      this.messageService.add({
        severity: this.status.SUCCESS,
        detail: 'Aadhaar Match Percentage updated successfully',
      });
    });
  }

  saveEsignValidityExpiry() {
    this.editEsignExpireValidity = false;
    let params = {
      account_id: this.account_id,
      esign_expires_in: this.esignExpireValidity,
    };
    this.userService.orderReviewConsent(params).subscribe((res) => {
      this.setEsignExpireValidity();
      this.messageService.add({
        severity: 'success',
        detail: 'Esign validity updated successfully',
      });
    });
  }
  toggleAccordionState(index: number): void {
    this.accordionOpenStates[index] = !this.accordionOpenStates[index];
  }
  private loadProcessOptionsByState(stateCode: string, index: number): void {
    this.preProcurementService.getStampTypeByState(stateCode).subscribe({
      next: (res: any) => {
        const content = res?.content?.[0];
        if (!content) return;

        const options = [];

        if (content.pre_estamp || content.traditional) {
          options.push({ label: 'Inventory', value: 'PRE_PROCUREMENT' });
        }
        if (content.estamp) {
          options.push({ label: 'On the Fly', value: 'ON_THE_FLY' });
        }
        if (content.esbtr) {
          options.push({ label: 'ESBTR', value: 'ESBTR' });
        }

        this.processOptionsAccount[index] = options;

        // Reset process_type since options changed
        const fieldGroup = this.estampDefaultFields.at(index) as FormGroup;
        fieldGroup.patchValue({ process_type: null }, { emitEvent: false });
      },
      error: (err) => {
        console.error('Failed to load stamp type by state:', err);
        this.processOptionsAccount[index] = [];
      },
    });
  }

  toggleEditLowEstampBalance() {
    this.editLowEstampBalance = !this.editLowEstampBalance;
  }

  toggleEditLowWalletBalance() {
    this.editLowWalletBalance = !this.editLowWalletBalance;
  }

  saveLowEstampBalance() {
    if (
      this.lowEstampBalanceAlert < 0 ||
      !Number.isInteger(Number(this.lowEstampBalanceAlert))
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Enter a non-negative whole number',
      });
      return;
    }
    let payload = {
      account_id: this.account_id,
      low_estamp_balance_alert: this.lowEstampBalanceAlert,
    };

    this.userService.orderReviewConsent(payload).subscribe((res: any) => {
      this.editLowEstampBalance = false;

      this.messageService.add({
        severity: 'success',
        detail: res.message,
      });
      this.setAccountSettings();
    });
  }

  saveLowWalletBalance() {
    if (
      this.lowWalletBalanceAlert < 0 ||
      !Number.isInteger(Number(this.lowWalletBalanceAlert))
    ) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Enter a non-negative whole number',
      });
      return;
    }

    let payload = {
      account_id: this.account_id,
      low_wallet_balance_alert: this.lowWalletBalanceAlert,
    };
    this.userService.orderReviewConsent(payload).subscribe((res: any) => {
      this.editLowWalletBalance = false;
      this.messageService.add({
        severity: 'success',
        detail: res.message,
      });
      this.setAccountSettings();
    });
  }

  validateBalanceAlert(type: string) {
    if (type === 'estamp') {
      this.lowEstampBalanceError =
        this.lowEstampBalanceAlert < 0 ||
        !Number.isInteger(Number(this.lowEstampBalanceAlert));
    }
    if (type === 'wallet') {
      this.lowWalletBalanceError =
        this.lowWalletBalanceAlert < 0 ||
        !Number.isInteger(Number(this.lowWalletBalanceAlert));
    }
  }
}
